// extracted by mini-css-extract-plugin
export default {"wrap":"s_wrap__r8TLl","buttonsWrap":"s_buttonsWrap__M3k0q","button":"s_button__7XFMF","icon":"s_icon__EIzrc","active":"s_active__ZPkZd"};